// src/layout/VoxShell.jsx
import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import "@/pages/ControlRoom/control-room.css"; // shared neon + menu styles

export default function VoxShell() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <div className="vox-app-shell">
      {/* ===== GLOBAL MENU BAR ===== */}
      <div className="vox-menu-bar">
        <div className="vox-brand">Vox OS</div>

        <div
          className="vox-menu-trigger"
          onClick={() => setMenuOpen((v) => !v)}
        >
          File
        </div>

        {menuOpen && (
          <div className="vox-menu-dropdown">
            <button onClick={() => go("/")}>Dashboard</button>
            <button onClick={() => go("/control-room")}>
              Control Room
            </button>
            <button onClick={() => setMenuOpen(false)}>
              Close Menu
            </button>
          </div>
        )}
      </div>

      {/* ===== PAGE CONTENT ===== */}
      <Outlet />
    </div>
  );
}
